'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var types = require('./types-942c6446.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var initialState = {
  page_size: 1,
  page: 0,
  total_pages: 1,
  total_items: 1,
  filter: {},
  items: [],
  item: {},
  tags: [],
  currentPost: {},
  clearForm: true,
  ok: true,
  message: "",
  image: null,
  errors: [],
  isPostLoading: false
};
function reducer () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.NEW_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        item: action.payload,
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message
      });
    case types.SELECT_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPost: action.payload
      });
    case types.NEW_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        item: action.payload
      });
    case types.SET_IS_POST_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isPostLoading: action.payload
      });
    case types.SET_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        filter: action.payload
      });
    case types.FETCH_POST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPost: action.payload.post,
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message,
        isPostLoading: false
      });
    case types.FETCH_POSTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: action.payload.data,
        page_size: action.payload.page_size,
        page: action.payload.page,
        total_pages: action.payload.total_pages,
        total_items: action.payload.total_items,
        ok: action.payload.ok,
        message: action.payload.message,
        errors: action.payload.errors
      });
    case types.SEARCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        items: action.payload.data,
        message: action.payload.message
      });
    case types.SEARCH_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message
      });
    case types.GET_ALL_TAGS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message,
        tags: action.payload.tags
      });
    case types.IMAGE_UPLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        errors: action.payload.errors,
        message: action.payload.message,
        image: action.payload.image
      });
    default:
      return state;
  }
}

module.exports = reducer;
